<div class="wallet-balance">
    <div>
        <span>Wallet balance</span>
        <span>₹{{ wallet_balance ? wallet_balance : 0 }}</span>
    </div>
    <button class="add-balance" routerLink="/wallet" (click)="closeSidebar()">
        <mat-icon>add</mat-icon>
    </button>
</div>
